import * as React from "react";
import { SVGProps } from "react";

export function SwapIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.06008 2.27301L8.00008 1.33301L14.0001 7.33301L10.7801 7.33301L2.66675 7.33301L2.66675 5.99967L10.7801 5.99967L7.06008 2.27301Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.60667 13.726L8.66667 14.666L2.66667 8.66602L5.88667 8.66602L14 8.66602L14 9.99935L5.88667 9.99935L9.60667 13.726Z"
        fill="currentColor"
      />
    </svg>
  );
}
